import React, { useState } from "react";
import airports from "../../../JSON/airports.json";
import { environment } from "../../SharePages/Utility/environment";
import moment from "moment";
import { Center, Divider } from "@chakra-ui/react";
import { FaDotCircle } from "react-icons/fa";

const MobileCard = ({
  item,
  totalPrice,
  name,
  index,
  onClick,
  selected,
  groupIndex,
  data,
  handleGroupFlightSelect,
  amountChange,
}) => {
  return (
    <div
      className="row mx-1 p-1 rounded box-shadow mb-4 position-relative"
      style={{
        border: selected === index ? "2px solid #068b9f" : "2px solid white",
        backgroundColor: selected === index ? "#badfe461" : "white",
        fontSize: "9px",
      }}
      key={index}
    >
      <div class="position-absolute" style={{ marginTop: "-15px" }}>
        {selected === index && (
          <span
            style={{ fontSize: "8px" }}
            className="p-1 bg-danger rounded w-auto fw-bold"
          >
            Selected
          </span>
        )}
      </div>

      <div className="mt-2 px-0">
        <img
          src={
            environment.s3ArliensImage + `${item[0]?.platingCarrierCode}.png`
          }
          alt=""
          width={"25px"}
          height={"25px"}
          className={"mb-1 rounded-2"}
        />
      </div>
      <div className="d-flex justify-content-between align-items-center gap-2 mb-1 px-0">
        <div className="fw-bold">
          <h6 className="text-start" style={{ color: "#068b9f" }}>
            {item[0]?.segments[0].airline}
          </h6>
          <p>
            {item[0]?.segments[0]?.airlineCode} -{" "}
            {item[0]?.segments[0]?.flightNumber}
          </p>
        </div>
        <div className="text-end">
          <span className="fw-bold">
            BDT{" "}
            <span className="fw-bold" style={{ fontSize: "11px" }}>
              {amountChange === "Invoice Amount" ? (
                <>
                  <div>
                    <span className="fw-bold">
                      {data?.brandedFares !== null
                        ? data.brandedFares?.[0]?.totalFare.toLocaleString(
                            "en-US"
                          )
                        : data?.bookingComponents[0]?.totalPrice?.toLocaleString(
                            "en-US"
                          )}
                    </span>
                  </div>

                  <div>
                    <del className="fw-bold">
                      {data.brandedFares !== null
                        ? (
                            data?.brandedFares?.[0]?.totalFare -
                            data?.brandedFares?.[0]?.discount
                          ).toLocaleString("en-US")
                        : (
                            data?.bookingComponents[0]?.totalPrice -
                            data?.bookingComponents[0]?.discountPrice
                          )?.toLocaleString("en-US")}
                    </del>
                  </div>
                </>
              ) : (
                <div>
                  <span className="fw-bold">
                    {data.brandedFares !== null
                      ? (
                          data.brandedFares?.[0]?.totalFare -
                          data?.brandedFares?.[0]?.discount
                        ).toLocaleString("en-US")
                      : (
                          data?.bookingComponents[0]?.totalPrice -
                          data?.bookingComponents[0]?.discountPrice
                        )?.toLocaleString("en-US")}
                  </span>
                </div>
              )}
            </span>
          </span>
        </div>
      </div>
      <div className="mx-0 px-0">
        <hr></hr>
      </div>
      <div className="d-flex justify-content-between align-items-center gap-2 my-1 px-0">
        <div className="fw-bold">
          <p>{name}</p>
          <h6 className="text-start" style={{ color: "#068b9f" }}>
            {item[0]?.segments[0].airline}
          </h6>
          <p>{moment(item[0]?.segments[0].departure).format("DD MMMM,YYYY")}</p>
        </div>
      </div>
      <div className="mx-0 px-0">
        <hr></hr>
      </div>
      <div className="container-fluid my-1 px-1">
        {item?.map((itm, idx) => (
          <>
            <div
              className="row py-1 fw-bold justify-content-between align-items-center rounded"
              key={index}
              style={{
                backgroundColor:
                  idx === groupIndex && selected === index
                    ? "#badfe5e0"
                    : "white",
                cursor: "pointer",
                zIndex: 1000,
              }}
              onClick={() => {
                handleGroupFlightSelect(idx);
                onClick(index);
              }}
            >
              <div className="col-2 d-flex flex-column align-items-center w-full">
                <FaDotCircle />
                <div
                  style={{
                    height: "60px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      width: "1px",
                      height: "100%",
                      backgroundColor: "black",
                    }}
                    className="d-flex flex-column align-items-center justify-content-center"
                  >
                    <i
                      className="fas fa-plane ms-2 fs-6"
                      style={{ transform: "rotate(90deg)" }}
                    ></i>
                  </div>
                </div>
                <FaDotCircle />
              </div>
              <div className="col-10">
                <div>
                  <p className="fw-bold" style={{ fontSize: "12px" }}>
                    {itm?.segments[0].departure.substr(11, 5)}
                  </p>
                  <p>
                    {moment(itm?.segments[0].departure).format("DD MMM,YY")}
                  </p>
                  <p className="fw-bold">
                    {airports
                      .filter((f) => f.iata === itm?.from)
                      .map((itm) => itm.city)}
                  </p>
                </div>
                <div className="my-1">
                  <i class="fas fa-clock fa-sm me-1"></i>
                  {itm?.segments[0].details[0].travelTime}{" "}
                  <i className="fas fa-plane fa-sm mx-1"></i>{" "}
                  {itm?.segments.length === 1
                    ? "Direct"
                    : itm?.segments.length - 1 + " Stop"}
                </div>
                <div>
                  <p className="fw-bold" style={{ fontSize: "12px" }}>
                    {itm?.segments[itm?.segments.length - 1].arrival.substr(
                      11,
                      5
                    )}
                  </p>
                  <p>
                    {moment(
                      itm?.segments[itm?.segments.length - 1].arrival
                    ).format("DD MMM,YY")}
                  </p>
                  <p className="fw-bold">
                    {airports
                      .filter((f) => f.iata === itm?.to)
                      .map((itm) => itm.city)}
                  </p>
                </div>
              </div>
            </div>
            <div className="my-1">
              <hr></hr>
            </div>
          </>
        ))}
      </div>
      <div className="text-end py-0">
        <span style={{ color: data?.avlSrc }}>
          <i className="fas fa-circle fa-sm"></i>
        </span>
        {data?.refundable === true ? (
          <>
            <span className="ms-1">
              {(data?.brandedFares === null ||
                data?.brandedFares === undefined ||
                data?.brandedFares?.length === 0) && (
                <>
                  <span className="text-success">
                    <i className="fas fa-circle fa-sm me-1"></i>
                  </span>
                  Refundable
                </>
              )}
            </span>
          </>
        ) : (
          <>
            <span className="ms-1">
              {(data?.brandedFares === null ||
                data?.brandedFares === undefined ||
                data?.brandedFares?.length === 0) && (
                <>
                  <span className="text-danger">
                    <i className="fas fa-circle fa-sm me-1"></i>
                  </span>
                  Non-Refundable
                </>
              )}
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default MobileCard;
